export default {
  'editorial-staff': 'Our editorial team',
  'published-on': 'Published on',
  'read-articles': 'Read their articles',
  'about-author': 'About the author',
}
